module.exports = __webpack_public_path__ + "media/site_templates/www.localfencingcompanies.com.au/images/feature_1-fec3ce3fd196abad5fbe1fabf83cde35.jpeg";